// extracted by mini-css-extract-plugin
var _1 = "loanpurposebuttons_active__pcq7g";
var _2 = "#4c4c4c";
var _3 = "loanpurposebuttons_button__ykipb";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "#434343";
var _8 = "loanpurposebuttons_iconwrapper__kniii";
var _9 = "79px";
var _a = "110px";
var _b = "72px";
var _c = "665px";
var _d = "loanpurposebuttons_right__q17ta";
var _e = "teal";
var _f = "2";
var _10 = "#cdd3dc";
var _11 = "loanpurposebuttons_togglebg__03vke";
var _12 = "loanpurposebuttons_togglebgwrapper__tanog";
var _13 = "loanpurposebuttons_wrapper__g+7jj";
export { _1 as "active", _2 as "body", _3 as "button", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "headline", _8 as "iconWrapper", _9 as "menuHeight", _a as "menuHeightLarge", _b as "menuHeightMobile", _c as "modalMobileWidth", _d as "right", _e as "teal", _f as "timelineStrokeWidth", _10 as "timelineTrackColor", _11 as "toggleBg", _12 as "toggleBgWrapper", _13 as "wrapper" }
